import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import { colors } from '../common';

export const ProgressCircle = ( { percentage, label, color, children, footer }
        : {percentage: number, label?: string, color?: string, children?: (string | JSX.Element | JSX.Element[]), footer?: string }) => {

    const classes = useStyles( { color } );

    return (
        <div className={ classes.root }>
            <div className="bar-overflow">
                <div className="bar" style={{ transform: `rotate(${45+(percentage*1.8)}deg)` }}></div>
                <div className="inner-text">
                    { children }
                </div>
                <div className="inner-footer" title={footer}>{footer}</div>
            </div>
            <span className="label">{ label }</span>
        </div>
    );
};

const useStyles = makeStyles({
    root : {
        position: 'relative',
        margin: '.25em',
        float: 'left',
        textAlign: 'center',

        "& .bar-overflow": {
            position: 'relative',
            overflow: 'hidden',
            width: '12em',
            height: '6em',
            marginBottom: '-1em',

            "& .bar": {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '12em',
                height: '12em',
                borderRadius: '50%',
                boxSizing: 'border-box',
                border: '.3em solid',
                borderColor: colors.lightGrey,
                borderBottomColor: ({color}: {color: string}) => colors[color] || colors.yellow,
                borderRightColor: ({color}: {color: string}) => colors[color] || colors.yellow,
            },
            "& .inner-text": {
                fontWeight: 500,
                position: 'absolute',
                top: '2em',
                left: 0,
                width: '12em'
            },
            "& .inner-footer": {
                fontWeight: 500,
                position: 'absolute',
                top: '3.5em',
                left: 0,
                width: '12em',
                height: 19,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            },
        },
        "& .label": {
            
            textTransform: 'uppercase',
            fontSize: 10
        }
    }
});
